export interface AnimeItem {
  id: string;
  title: string;
  score: number;
  year: number;
  episodes: number;
  category: string;
  tags: string[];
  synopsis: string;
  image: string;
  badge?: string;
}

export const animeList: AnimeItem[] = [
  {
    id: 'xingxie-lieche',
    title: '星屑列车',
    score: 9.6,
    year: 2024,
    episodes: 24,
    category: '高分番',
    tags: ['科幻', '治愈', '群像'],
    synopsis: '一列穿梭于星际废墟的夜班列车，载着形形色色的旅客寻找失落的故乡。每一站都是一段关于告别与重逢的温柔故事，作画与配乐都被称作近年现象级。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20illustration%20of%20a%20night%20train%20flying%20through%20nebulae%20and%20ruins%2C%20warm%20orange%20and%20teal%20lighting%2C%20dreamy%20cinematic%20starfield%20sky%2C%20silhouette%20passengers%20by%20the%20window%2C%20soft%20glow%2C%20hand%20painted%20anime%20style%20with%20high%20detail%20and%20beautiful%20composition&width=600&height=900&seq=poster-starlight&orientation=portrait',
  },
  {
    id: 'huiwei-zhiyi',
    title: '灰白之翼',
    score: 9.4,
    year: 2023,
    episodes: 13,
    category: '冷门佳作',
    tags: ['奇幻', '战斗', '成长'],
    synopsis: '被遗弃的少年在云海之上驯养会发光的灰白飞鸟，一步一步揭开自己被抹去的记忆。冷门却口碑极佳，慢热的叙事在后半段全面爆发。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20boy%20riding%20a%20glowing%20white%20bird%20above%20a%20sea%20of%20clouds%20at%20sunset%2C%20warm%20orange%20and%20teal%20sky%2C%20wind%20swept%20feathers%2C%20hand%20painted%20cinematic%20anime%20style%2C%20emotional%20atmosphere%20and%20fine%20detail&width=600&height=900&seq=poster-ashwing&orientation=portrait',
  },
  {
    id: 'xiangwei-mao',
    title: '巷尾的猫与月亮',
    score: 9.5,
    year: 2022,
    episodes: 12,
    category: '完结番',
    tags: ['日常', '治愈', '温情'],
    synopsis: '一条老旧巷子里的流浪猫，每晚都会等一个加班归来的女生。细腻到令人落泪的日常系作品，看完只想抱紧身边的猫。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20stray%20cat%20sitting%20under%20a%20large%20warm%20moon%20in%20an%20old%20city%20alley%2C%20orange%20lantern%20light%2C%20cozy%20nostalgic%20night%20scene%2C%20soft%20warm%20tone%2C%20hand%20painted%20anime%20illustration%20with%20gentle%20atmosphere&width=600&height=900&seq=poster-catmoon&orientation=portrait',
  },
  {
    id: 'canghai-mingzhu',
    title: '沧海明珠',
    score: 9.7,
    year: 2025,
    episodes: 26,
    category: '高分番',
    tags: ['古风', '冒险', '剧情'],
    synopsis: '寻宝少女与沉默船医横渡七片海域，只为找回失落的海底明珠。制作精良、剧情紧凑，是近五年最被看好的冒险群像剧。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20sailor%20girl%20and%20a%20doctor%20on%20a%20ship%20crossing%20a%20mysterious%20glowing%20sea%2C%20warm%20amber%20and%20teal%20waves%2C%20legendary%20pearl%20glow%20under%20water%2C%20epic%20hand%20painted%20anime%20style%20with%20rich%20detail%20and%20adventure%20mood&width=600&height=900&seq=poster-seapearl&orientation=portrait',
  },
  {
    id: 'qianye-shenghua',
    title: '千夜生花',
    score: 9.3,
    year: 2021,
    episodes: 12,
    category: '冷门佳作',
    tags: ['文艺', '青春', '慢热'],
    synopsis: '两个在深夜电台相遇的人，用一千个夜晚互相治愈彼此破碎的人生。冷门文艺向，台词精致，适合一个人安静看完。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20quiet%20night%20radio%20studio%20with%20two%20people%20under%20a%20warm%20lamp%2C%20midnight%20city%20lights%20through%20window%2C%20blooming%20flowers%20on%20the%20desk%2C%20nostalgic%20warm%20tone%2C%20hand%20painted%20cinematic%20anime%20illustration&width=600&height=900&seq=poster-thousandnight&orientation=portrait',
  },
  {
    id: 'huoyu-zhiyao',
    title: '火羽之曜',
    score: 9.2,
    year: 2020,
    episodes: 25,
    category: '完结番',
    tags: ['热血', '战斗', '王道路线'],
    synopsis: '废柴少年继承了传说中的火羽之力，在被轻视的学院里一步步登上巅峰。热血到让人握紧拳头，燃点与泪点并存。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20young%20hero%20igniting%20flaming%20phoenix%20feathers%20in%20both%20hands%20under%20a%20dramatic%20orange%20sky%2C%20epic%20battle%20energy%2C%20embers%20flying%2C%20hand%20painted%20shonen%20anime%20style%20with%20dynamic%20pose%20and%20high%20contrast&width=600&height=900&seq=poster-firefeather&orientation=portrait',
  },
  {
    id: 'yuehe-tiandeng',
    title: '月河天灯',
    score: 9.4,
    year: 2024,
    episodes: 12,
    category: '口碑番',
    tags: ['古风', '奇幻', '爱情'],
    synopsis: '少女在月河畔放飞天灯，只为让千年前的心愿被看见。画面美到窒息，被无数观众反复二刷的年度口碑之作。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20girl%20releasing%20glowing%20sky%20lanterns%20over%20a%20moonlit%20river%2C%20hundreds%20of%20warm%20orange%20lights%20floating%20up%2C%20reflection%20on%20water%2C%20romantic%20hand%20painted%20anime%20style%20with%20dreamy%20atmosphere&width=600&height=900&seq=poster-moonlantern&orientation=portrait',
  },
  {
    id: 'shuihu-xingdeng',
    title: '水户星灯',
    score: 9.1,
    year: 2019,
    episodes: 22,
    category: '完结番',
    tags: ['冒险', '奇幻', '群像'],
    synopsis: '水边小镇每年点亮一次星灯，今年却意外唤醒了沉睡的海神。剧情环环相扣，结局干净利落，适合一口气补完。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20seaside%20town%20night%20festival%20with%20floating%20star%20lanterns%20on%20water%2C%20a%20giant%20sea%20spirit%20rising%20from%20the%20ocean%2C%20warm%20orange%20and%20teal%20moonlight%2C%20hand%20painted%20anime%20style%20with%20epic%20atmosphere&width=600&height=900&seq=poster-waterlantern&orientation=portrait',
  },
  {
    id: 'moyu-xiaozhan',
    title: '墨羽小站',
    score: 9.0,
    year: 2023,
    episodes: 10,
    category: '冷门佳作',
    tags: ['悬疑', '治愈', '短篇'],
    synopsis: '废弃车站里唯一还在运行的一班车，只搭载心里有遗憾的人。冷门悬疑与治愈并存，看完后劲十足。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20an%20abandoned%20railway%20station%20with%20a%20single%20warm%20lit%20train%20waiting%20at%20night%2C%20moody%20fog%2C%20ink%20colored%20clouds%2C%20mysterious%20and%20cozy%2C%20hand%20painted%20cinematic%20anime%20style%20with%20soft%20warm%20light&width=600&height=900&seq=poster-inkstation&orientation=portrait',
  },
  {
    id: 'chixing-hujian',
    title: '赤星护剑',
    score: 9.3,
    year: 2022,
    episodes: 24,
    category: '口碑番',
    tags: ['武侠', '战斗', '复仇'],
    synopsis: '背负灭门之仇的少女，带着一把会说话的赤星剑走上复仇之路。打斗分镜被业内奉为教科书，口碑常年居高不下。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20swordswoman%20holding%20a%20glowing%20red%20sword%20against%20a%20fiery%20sky%2C%20dramatic%20battle%20pose%2C%20cherry%20petals%20and%20embers%20in%20wind%2C%20wuxia%20hand%20painted%20anime%20style%20with%20dynamic%20action%20and%20high%20energy&width=600&height=900&seq=poster-redstar&orientation=portrait',
  },
  {
    id: 'qianliu-yiye',
    title: '千流一夜',
    score: 8.9,
    year: 2021,
    episodes: 12,
    category: '冷门佳作',
    tags: ['奇幻', '文艺', '梦境'],
    synopsis: '每晚做同一个梦的少年，发现梦里有一条从未在地图上出现过的河。冷门文艺向，画风独特，适合喜欢慢节奏的观众。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20boy%20standing%20at%20the%20edge%20of%20a%20dream%20river%20that%20mirrors%20the%20night%20sky%2C%20stars%20flowing%20in%20water%2C%20surreal%20dreamlike%20warm%20tone%2C%20hand%20painted%20cinematic%20anime%20illustration%20with%20soft%20light&width=600&height=900&seq=poster-river&orientation=portrait',
  },
  {
    id: 'zhixing-pomo',
    title: '纸星破魔',
    score: 9.2,
    year: 2025,
    episodes: 13,
    category: '完结番',
    tags: ['奇幻', '战斗', '反套路'],
    synopsis: '一个只会折纸的阴阳师，用折出来的星星封印了世间最强的魔物。反套路设定与紧凑节奏，完结季口碑全面爆发。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20an%20onmyoji%20folding%20a%20shining%20paper%20star%20that%20seals%20a%20dark%20demon%20spirit%2C%20magical%20glowing%20particles%2C%20warm%20orange%20and%20teal%20duality%2C%20hand%20painted%20anime%20style%20with%20mystical%20energy&width=600&height=900&seq=poster-paperstar&orientation=portrait',
  },
  {
    id: 'haiyan-shaonv',
    title: '海盐少女与夏日',
    score: 9.0,
    year: 2020,
    episodes: 13,
    category: '口碑番',
    tags: ['青春', '日常', '夏日'],
    synopsis: '海边小城的最后一个夏天，少女与伙伴们骑着单车追着海风。治愈到骨子里的青春群像，夏日必补。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20teenage%20girls%20riding%20bicycles%20along%20a%20sunlit%20coastal%20road%20under%20a%20warm%20afternoon%20sky%2C%20sea%20breeze%20and%20white%20clouds%2C%20youthful%20nostalgic%20hand%20painted%20anime%20style%2C%20bright%20warm%20summer%20mood&width=600&height=900&seq=poster-seasalt&orientation=portrait',
  },
  {
    id: 'kuangming-lan',
    title: '狂明之岚',
    score: 9.5,
    year: 2023,
    episodes: 26,
    category: '高分番',
    tags: ['热血', '竞技', '友情'],
    synopsis: '一群追梦少年在极限赛车场上逆风翻盘。节奏燃到飞起，友情与热血的教科书级作品，熬夜也要一口气看完。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20team%20of%20young%20racers%20driving%20futuristic%20vehicles%20through%20a%20storm%20at%20sunset%2C%20orange%20lightning%20and%20wind%20trails%2C%20epic%20sports%20anime%20style%20with%20dynamic%20speed%20and%20energy&width=600&height=900&seq=poster-storm&orientation=portrait',
  },
  {
    id: 'yueli-jiudian',
    title: '月里小酒馆',
    score: 9.1,
    year: 2022,
    episodes: 12,
    category: '完结番',
    tags: ['美食', '治愈', '群像'],
    synopsis: '开在月亮背面的一家小酒馆，每个夜晚招待一位迷路的客人，用一道菜换一个故事。深夜看会饿，但也真的很暖。',
    image: 'https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20cozy%20little%20tavern%20on%20the%20dark%20side%20of%20the%20moon%2C%20warm%20glowing%20lanterns%20and%20steaming%20food%2C%20curious%20guests%20at%20tables%2C%20hand%20painted%20anime%20style%20with%20inviting%20warm%20light%20and%20whimsical%20detail&width=600&height=900&seq=poster-moontaver&orientation=portrait',
  },
];

export const topRated: AnimeItem[] = [...animeList].sort((a, b) => b.score - a.score).slice(0, 5);

export const hiddenGems: AnimeItem[] = animeList.filter((i) => i.category === '冷门佳作');
export const completed: AnimeItem[] = animeList.filter((i) => i.category === '完结番');
export const review: AnimeItem[] = animeList.filter((i) => i.category === '口碑番');

export const categories = ['全部', '高分番', '冷门佳作', '完结番', '口碑番'];

export const faqs = [
  {
    q: '小虎看番的片单是怎么选出来的？',
    a: '小虎的每一份片单都综合了豆瓣、B站、Bangumi 等多平台评分、完播率与观众口碑，再经过人工逐部试看筛选，确保推荐的每一部都真正值得看完，而不是单纯堆评分。',
  },
  {
    q: '榜单里的评分是实时更新的吗？',
    a: '我们会定期校准各平台评分并同步更新片单。榜单更多是作为参考方向，实际好不好看，建议结合你自己的喜好和片单里的"看点说明"来判断。',
  },
  {
    q: '冷门佳作会不会太难找资源？',
    a: '冷门佳作不等于冷门资源，我们挑选的片单基本都能在主流正版平台找到。遇到个别比较难找的，片单详情里也标注了观看建议。',
  },
  {
    q: '完结番合集适合一次性补完吗？',
    a: '非常适合。完结番集数相对稳定、故事完整，不用担心追更断档。我们的完结番合集特意标注了集数与风格，方便你选一部趁周末一口气刷完。',
  },
  {
    q: '可以给小虎投稿推荐番剧吗？',
    a: '当然可以！如果你发现了宝藏番，欢迎通过页面底部或订阅表单告诉我们，优质片单一经采纳就会署名收录进小虎的补番清单。',
  },
];